/* eslint-disable */
<template>
  <div class="positionMainContainer main-container">
      <div class = "displayContainer">
        <RhsBanner
            :bannerMessage="bannerMessage"
        />
            <ValidationObserver slim v-slot="{ invalid }">
                <div class="leftpanel-container">
                    <div class="register" v-if="registrationStep === 1">
                        <div class="register--container">
                            <p class="register--title mb-0">Register</p>
                            <p class="register--subtitle">To continue enter you mobile number.</p>
                            <div class="register__form mt-40">
                                <ValidationProvider name="Mobile No." rules="digits:10|required" v-slot="{ errors, classes }">
                                    <div class="input-group mb-5" :class="classes">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">
                                                <img src = "/img/phoneNumber.svg" alt = "Phone Number">
                                            </span>
                                        </div>
                                        <input onKeyPress="if(this.value.length==10) return false;" type="number" id="mobile" class="form-control" v-model="phoneNo" maxLength="10" placeholder="9000090000">
                                    </div>
                                    <small class="form-group--error-message">{{ errors[0] }}</small>
                                </ValidationProvider>
                                <!-- <emergency-banner
                                :message="messageMain"/> -->
                                <ValidationProvider name="Terms and Conditions" rules="checkbox">
                                    <div class="checkbox">
                                        <v-checkbox
                                            v-model="checkbox"
                                        ></v-checkbox>
                                        <div>
                                            <div class="small pb-25">I agree with IndiaP2P
                                                <a target="_blank" rel="noreferrer noopener" href="https://indiap2pemailtemplateasset.s3.ap-south-1.amazonaws.com/IndiaP2_PPrivacyPolicy.pdf">Privacy Policy and Terms & Conditions</a>.
                                            </div>
                                        </div>
                                    </div>
                                    <ReCaptcha
                                    ref="recaptcha"
                                    :captchaError="captchaError"
                                    :captchaErrorText="captchaErrorText"
                                    @GetToken="setReCaptchaToken"
                                    />
                                </ValidationProvider>
                                <ValidationProvider name="Referral Code" rules="lengthBetween:5,6|alpha_num" v-slot="{ errors}">
                                    <div class="register__form__referral">
                                        <div class="referralCode mb-15" v-if="showReferralField">
                                            <div class="input-group mb-15 error-refer">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">
                                                        <v-icon style = "color: #9e9e9e !important" class="material-icons-round">loyalty</v-icon>
                                                    </span>
                                                </div>
                                                <input :disabled="disabled == 1" maxLength="6" type="text" id="refferral" class="form-control" v-model="referralCode" placeholder="Referral code">
                                            </div>
                                            <small class="form-group--error-message">{{ errors[0] }}</small>
                                            <div class="w-100 d-flex aligin-items-center justify-content-between mt-10">
                                            </div>
                                        </div>
                                    </div>
                                </ValidationProvider>
                            </div>
                                <div class="register__form--referral-bottom">
                                    <a style = "color: #002FA7 !important; font-weight: 600" class="register__form__referral--text" @click="showReferralField = true" v-if="!showReferralField"> Have a referral code?</a>
                                    <div style="display: flex; justify-content: center; align-items: center">
                                        <button class="signup-step1 btn_new btn-secondary-new w-80 mt-15" @click="receiveOtp" :disabled="invalid">Next </button>
                                    </div>
                                </div>
                            <a v-if = "showLogin" class="register__form__referral--text" style="margin-top: 24px; color: #8c8c8c !important;">Already have an account? <a class = "loginText" @click="redirectToLogin"> Login </a> </a>

                        </div>
                    </div>
                    <div style = "position: relative;" class="register" v-else-if="registrationStep === 2">
                        <div style = "position: absolute; top: 0px;" class="backButtonOne">
                            <button class="btn-back btn w-45px mt-15 mb-15" @click="clearMobileField">
                                <v-icon class="material-icons-round"> arrow_back </v-icon>
                            </button>
                        </div>
                        <div style = "position: relative; top: 60px;" class="register--container">
                            <p class="register--title mb-0">Verification Code</p>
                            <p class="register--subtitle">
                                We have sent a 6 digit code to
                                <a><strong>{{phoneNo}}.</strong></a></p>
                            <ValidationProvider name="OTP" rules="digits:6|required" v-slot="{ classes }">
                                <div>
                                    <div :class="classes">
                                        <v-otp-input
                                        v-model="otp"
                                        type="number"
                                        @finish="confirmOtp"
                                        ></v-otp-input>
                                    </div>

                                </div>
                                <ReCaptcha
                                    v-if="showCaptcha"
                                    ref="recaptcha"
                                    :captchaError="captchaError"
                                    :captchaErrorText="captchaErrorText"
                                    :step="registrationStep"
                                    @GetToken="setReCaptchaToken"
                                    @SubmitGetOtp="receiveOtp"
                                    />
                            </ValidationProvider>
                            <div class="otp mt-15 w-100">
                                <div v-if="!otpTime" class="rightAlign">
                                    <p class="otp--resend" >
                                        Did not receive OTP? <a @click="receiveOtp" class="ml-5"> Resend </a>
                                    </p>
                                </div>
                                <div class="rightAlign" v-else>
                                    <p class="otp--timer">
                                        You can resend the OTP in {{otpTime}} sec
                                    </p>
                                </div>
                            </div>
                            <!-- <emergency-banner
                            :message="messageOtp"/> -->
                            <div style="display: flex; justify-content: center; align-items: center" class="register__form--referral-bottom">
                                <button class="signup-step2 btn_new btn-secondary-new w-80 mt-15 mb-15" @click="checkOtp" :disabled="invalid">Next </button>
                            </div>
                        </div>
                    </div>
                </div>
            </ValidationObserver>
        </div>
        <div class="footerText">Copyright 2022: Trickle Flood Technologies Pvt Ltd, All Rights Reserved</div>
        <v-snackbar
            v-model="otpFailureSnackbar"
            app
            top
            timeout="-1"
            color="#FFF3F3"
        >
                {{ snackBarText }}
                <div v-if="attemptsRemaining && !isBlockedFromSignup">
                    {{  attemptsRemaining  }} Attempt(s) remaining.
                </div>

            <template v-slot:action="{ attrs }">
                <v-icon @click="otpFailureSnackbar = false" color="red" v-bind="attrs">
                    fas fa-times-circle
                </v-icon>
                <!-- <v-btn
                    color="red"
                    text
                    v-bind="attrs"
                    @click="otpFailureSnackbar = false"
                >
                    Close
                </v-btn> -->
            </template>
        </v-snackbar>
    </div>
</template>
<script>
import onboardingService from '@/services/lenderOnboardingService'
import RhsBanner from '../components/common/right-side-banner/rhs-banner.vue'
// import emergencyBanner from '../components/common/emergencyMessageBanner.vue'
import ReCaptcha from '../components/lenderOnboarding/reCaptcha.vue'

const { setCookie, assignOnBoardingStep } = require('@/util/util.js')

export default {
    name: 'Register',
    components: {
        RhsBanner,
        ReCaptcha
        // emergencyBanner
    },
    data () {
        return {
            messageMain: "We're encountering SMS delivery problems and actively addressing them. We appreciate your patience as we work to resolve this issue swiftly.",
            messageOtp: 'SMS and email sent to your registered contacts. We are facing issues with our SMS channels. kindly use email for OTP.',
            showLogin: true,
            disabled: 0,
            registrationStep: 1,
            pinLength: 6,
            showReferralField: false,
            phoneNo: '',
            referralCode: null,
            otp: '',
            otpTime: 0,
            bannerMessage: 'You are just a few  clicks away from creating your Investment Profile',
            otpFailureSnackbar: false,
            checkbox: false,
            reCaptchaToken: null,
            captchaError: false,
            showCaptcha: false,
            captchaErrorText: 'Please Select Captcha',
            campaignName: '',
            snackBarText: 'Incorrect OTP',
            attemptsRemaining: 0,
            isBlockedFromSignup: false
        }
    },
    watch: {
        otpTime: {
            handler (value) {
                if (value > 0) {
                    setTimeout(() => {
                        this.otpTime--
                    }, 1000)
                } else {
                    this.otpTime = 0
                }
            },
            immediate: true
        },
        otp: {
            handler (value) {
                if (value.length === 6) {
                    this.checkOtp(value)
                }
            },
            deep: true,
            immediate: true
        }
    },
    mounted () {
        if (this.$route.query.ref) {
            this.showReferralField = true
            this.referralCode = this.$route.query.ref
        }
        const urlParams = new URLSearchParams(window.location.search)
        var channelPartnerUrl = urlParams.get('ps')
        var campaign = urlParams.get('utm_campaign')
        if (campaign) {
            this.campaignName = campaign
        }
        if (channelPartnerUrl) {
            if (!/\.?www./g.test(channelPartnerUrl)) {
                channelPartnerUrl = channelPartnerUrl.replace('://', '://www.')
            }
            var lastLetter = channelPartnerUrl.charAt(channelPartnerUrl.length - 1)
            if (lastLetter !== '/') {
                channelPartnerUrl = channelPartnerUrl + '/'
            }
            this.getChannelPartnerDetails(channelPartnerUrl)
            this.$store.commit('isLoading')
        }
    },
    methods: {
        setReCaptchaToken (token) {
            this.reCaptchaToken = token
        },
        confirmOtp (otp) {
            this.otp = otp
        },
        getChannelPartnerDetails (channelPartnerUrl) {
            const query = 'redirectUrl=' + channelPartnerUrl
            onboardingService.getChannelPartner(query).then((response) => {
                if (response.status === 200) {
                    this.$store.commit('isNotLoading')
                    this.showReferralField = true
                    this.referralCode = response.data[0].generatedReferralCode
                    this.disabled = 1
                    this.showLogin = false
                } else if (response.status === 400) {
                    this.$store.commit('isNotLoading')
                } else {
                    this.$store.commit('isNotLoading')
                }
                this.$store.commit('isNotLoading')
            }).catch((err) => {
                console.log('error', err)
                this.$store.commit('isNotLoading')
            })
        },
        clearMobileField () {
            this.phoneNo = ''
            this.otp = ''
            this.registrationStep = 1
            this.$refs.recaptcha.loadCaptchaScript()
        },
        receiveOtp () {
            if (!this.reCaptchaToken) {
                // this.$refs.recaptcha.loadCaptchaScript()
                this.captchaError = true
                this.captchaErrorText = 'Please Select Captcha'
                if (this.registrationStep === 2) this.showCaptcha = true
                return
            }
            this.$store.commit('isLoading')
            const payload = {
                phoneNo: this.phoneNo,
                referralCode: this.referralCode,
                type: 'lender'
            }
            const headers = {
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-',
                'x-recaptcha-token': this.reCaptchaToken
            }
            onboardingService.signupInit(payload, headers).then((res) => {
                this.$store.commit('isNotLoading')
                if (res.status === 200) {
                    this.otpTime = 30
                    this.registrationStep = 2
                    this.reCaptchaToken = null
                    this.showCaptcha = false
                    this.otp = ''
                } else {
                    this.snackBarText = res.data.message ? res.data.message : 'Something went wrong!'
                    this.otpFailureSnackbar = true
                }
                if (res.status === 429) {
                    // this.registrationStep = 1
                    // this.captchaErrorText = 'Captcha Expired! Please Try Again'
                    // this.captchaError = true
                    this.$refs.recaptcha.resetCaptcha()
                }
            }).catch((err) => {
                console.log('error', err)
                this.snackBarText = err?.response?.data?.message ? err?.response?.data?.message : 'Something went wrong!'
                this.otpFailureSnackbar = true
                this.$store.commit('isNotLoading')
            })
        },
        checkOtp (otp) {
            this.$store.commit('isLoading')
            const payload = {
                phoneNo: this.phoneNo,
                referralCode: this.referralCode,
                otp: otp,
                type: 'lender',
                campaignName: this.campaignName
            }
            onboardingService.signupVerify(payload).then((res) => {
                if (res.status === 200) {
                    setCookie('token', res.data.user.token, 1)
                    const user = res.data.user
                    this.$store.dispatch('dashboard/setField', { field: 'generatedReferralCode', value: res.data.user?.userDetails?.generatedReferralCode })
                    this.$store.dispatch('dashboard/setField', { field: 'userId', value: user.userDetails.userId })
                    if (user.userDetails.isLenderContractSigned) {
                        this.$store.dispatch('setUserName', user.userDetails.name)
                        this.$store.dispatch('onBoarding/setField', { field: 'Name', value: res.data.user.userDetails.name ? res.data.user.userDetails.name : '' })
                        this.$store.dispatch('dashboard/setField', { field: 'isLenderContractSigned', value: true })
                        this.$store.dispatch('dashboard/setField', { field: 'phoneNo', value: this.phoneNo })
                        this.$store.dispatch('dashboard/setField', { field: 'profileImage', value: user.userDetails?.userPhoto?.url })
                        this.$store.dispatch('onBoarding/setField', { field: 'Email', value: user.userDetails.emailId })
                        this.$router.push('/dashboard')
                    } else {
                        const step = assignOnBoardingStep(res.data)
                        this.$store.dispatch('setUserName', user.userDetails.name)
                        this.$store.dispatch('onBoarding/setStep', step)
                        this.$store.dispatch('dashboard/setField', { field: 'phoneNo', value: this.phoneNo })
                        if (res.data.user.userDetails.isSignupComplete) {
                            this.$store.dispatch('onBoarding/setField', { field: 'showIntermediateStep', value: true })
                        }
                        this.success()
                    }
                } else {
                    console.log('im here', res)
                    this.snackBarText = res.data.message ? res.data.message : 'Incorrect OTP'
                    this.isBlockedFromSignup = res.data?.result?.isBlocked || false
                    this.attemptsRemaining = res.data?.result?.attemptsRemaining
                    this.failure()
                }
                this.$store.commit('isNotLoading')
            }).catch((err) => {
                console.log('error', err)
                this.snackBarText = err.response.data.message ? err.response.data.message : 'Incorrect OTP'
                this.$store.commit('isNotLoading')
            })
        },
        redirectToLogin () {
            this.$router.push('/login')
        },
        success () {
            this.$router.push('/onboarding')
        },
        failure () {
            this.otp = ''
            this.otpTime = 0
            this.otpFailureSnackbar = true
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "~@/sass/components/registration-flow.scss";
    .error-refer {
        margin-bottom: 8px !important;
    }

    ::v-deep .v-snack__content {
        color: #FF0000;
    }

    .signup-step1 {
    }
    .signup-step2 {
    }
    .otp-input-wrap {
        justify-content: space-around;
    }

    .rightAlign {
        text-align: right;
    }

    .checkbox {
        display: flex;
        align-items: center;
    }

    .otp--resend {
        color: #666e75 !important;
    }

    ::v-deep .v-input__slot {
        margin-bottom: 32px;
    }
    ::v-deep .v-otp-input {
        height: 72px;
    }
    ::placeholder {
        color: #e0e0e0
    }
    ::v-deep .v-text-field--outlined > .v-input__control > .v-input__slot {
        min-height: 45px;
        max-width: 45px;
    }
    .positionMainContainer {
        display: flex !important;
        flex-direction: column !important;
        min-height: 100% !important;
        position: relative !important;
    }
    .footerText {
        text-align: center;
        padding-bottom: 10px;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 30px;
        font-size: 12px;
    }
    .displayContainer {
        display: flex;
        flex-direction: row;
        width: 100%;
        height: 100%
    }

    @media (max-width: 990px) {
        .displayContainer {
        display: flex !important;
        flex-direction: column-reverse !important;
        }
    }
    .loginText {
        color: #002fa7 !important;
        font-weight: 700 !important;
    }

    .attemptRemaining {
        background-color: #FFF3F3;
        color: #FF0000;
        border-radius: 8px;
    }
</style>
